import { hseSiteConfig } from '../config/hse/site.config';

export const environment = {
  production: false,
  x_api_key: 'w3NQFPoUOSqE29k6PPD4XDnOOPd9uf5X',
  apiUrl: 'https://api-hse-dev.kozaca.com.ar/api',
  apiUrl_photo: 'https://api-hse-dev.kozaca.com.ar',
  portalUrl: 'https://pacientes-hse-dev.kozaca.com.ar',
  auth: {
    clientId: '019f8542-a091-72fd-99d5-488a53e361cd',
    clientSecret: '6LpykxF6BSISMzCS9NNejrDnvRqAYQKxvQm9Gfxx',
  },
  siteConfig: hseSiteConfig,
};
